/* global angular */
import template from '../../templates/cognito-modal.html';
import logo from '../../templates/atex-logo.svg';

const COMPONENT_NAME = 'cognitoModal';

const popupWindow = (url, name, win, w, h) => {
  const y = 200; // win.top.outerHeight / 2 + win.top.screenY - ( h / 2);
  const x = win.top.outerWidth / 2 + win.top.screenX - ( w / 2);
  return win.open(url, name, 'toolbar=0, location=0, directories=0, status=0, menubar=0, scrollbars=0, resizable=0, copyhistory=0, width='+w+', height='+h+', top='+y+', left='+x);
};

angular.module ('atex.aceui.authentication')
  .component (COMPONENT_NAME, {
    template,

    bindings: {
      resolve: '<',
      close: '&',
      dismiss: '&'
    },

    controller: ['$interval', '$timeout', '$translate', '$window', 'AuthenticationService',
      function ($interval, $timeout, $translate, $window, AuthenticationService) {
        const $ctrl = this;
        let listening = false;

        $ctrl.loginUsingAce = () => {
          $ctrl.loginInProgress = false;
          $ctrl.close ({ $value: { loginUsingAce: true } });
        };

        window._loginUsingAce = $ctrl.loginUsingAce;

        $ctrl.logout = () => {
          AuthenticationService.logout ();
        };

        $ctrl.goToLogin = () => {
          if ($ctrl.loginInProgress) {
            $ctrl.loginWindow.focus();
            return;
          }
          $ctrl.loginInProgress = true;
          let channel = new BroadcastChannel('ace-cognito');

          $ctrl.loginWindow = popupWindow ($ctrl.resolve.url, 'ace-login', $window, 400, 450);

          let cancelCheck = $interval (() => {
            if ($ctrl.loginWindow.closed) {
              $ctrl.loginInProgress = false;
              $timeout ($ctrl.errorMsg = 'cognito.error.sign-in-aborted.text');
              $interval.cancel(cancelCheck);
            }
          }, 250);

          if (!listening) {
            listening = true;
            channel.addEventListener ('message', (event) => {
              $interval.cancel(cancelCheck);
              $timeout ($ctrl.loginWindow.close, 300);
              AuthenticationService.login ({ username: $ctrl.resolve.user, exchange: event.data.id_token })
                .then((user) => {
                  $ctrl.loginInProgress = false;
                  $ctrl.close({ $value: { user }});
                })
                .catch ((error) => {
                  console.error('error', error);
                  $ctrl.errorMsg =
                    error.rootCause.message
                    || (error.rootCause.responseJSON && error.rootCause.responseJSON.message)
                    || error.rootCause.responseText;
                  $ctrl.loginInProgress = false;
                });
              listening = false;
            }, { once: true });
          }
        };

        $ctrl.$onDestroy = () => {
          if ($ctrl.loginWindow && !$ctrl.loginWindow.closed) {
            $ctrl.loginWindow.close();
          }
          window._loginUsingAce = undefined;
        };

        $ctrl.$onInit = () => {
          $ctrl.signInLabel = 'cognito.sign-in.label';
          $ctrl.signingInLabel = 'cognito.signing-in.label';
          $ctrl.logo = logo;
          $ctrl.user = $ctrl.resolve.user;
          if ($ctrl.user) {
            $ctrl.errorMsg = 'cognito.sign-in-continue.label';
          }
          $ctrl.aceLoginEnabled = $ctrl.resolve.aceLoginEnabled;
        };
      }]
  });

export default COMPONENT_NAME;
